export const types = ['primary', 'secondary', 'outlined', 'clear', 'buy'];
export const sizeClasses = ['xlarge', 'large', 'medium', 'small', 'xsmall'];
export const textTransform = 'uppercase';
export const fontWeight = 700;
export const borderWidth = '1px';

export const backgroundColors = {
  primary: '#EED351',
  secondary: '#292929',
  outlined: 'unset',
  clear: 'unset',
  buy: '#346350',
};

export const fontColors = {
  primary: '#171717',
  secondary: '#FFFFFF',
  outlined: '#171717',
  clear: '#171717',
  buy: '#FFFFFF',
};

export const hoverBackgroundColors = {
  primary: '#BEA941',
  secondary: '#212121',
  outlined: '#FAFAFA',
  clear: '#FAFAFA',
  buy: '#2A4F40',
};

export const focusBackgroundColors = {
  primary: '#8F7F31',
  secondary: '#191919',
  outlined: '#F5F5F5',
  clear: '#F5F5F5',
  buy: '#1F3B30',
};

export const borderColors = {
  primary: '#EED351',
  secondary: '#292929',
  outlined: '#D4D4D4',
  clear: 'rgba(0,0,0,0)',
  buy: '#346350',
};

export const hoverBorderColors = {
  primary: '#BEA941',
  secondary: '#212121',
  outlined: '#D4D4D4',
  clear: '#FAFAFA',
  buy: '#2A4F40',
};

export const focusBorderColors = {
  primary: '#8F7F31',
  secondary: '#191919',
  outlined: '#D4D4D4',
  clear: '#F5F5F5',
  buy: '#1F3B30',
};

export const paddings = {
  xlarge: '1.6rem',
  large: '1.2rem',
  medium: '0.8rem 1rem',
  small: '0.8rem',
  xsmall: '0.4rem 0.8rem',
};

export const fontSizes = {
  xlarge: '1.6rem',
  large: '1.6rem',
  medium: '1.4rem',
  small: '1.2rem',
  xsmall: '1rem',
};

export const lineHeights = {
  xlarge: '2.4rem',
  large: '2.4rem',
  medium: '2.4rem',
  small: '1.6rem',
  xsmall: '1.6rem',
};
